module.exports = __webpack_public_path__ + "static/media/gender.9927a676.svg";